import { BadgeProps } from '@levelSystem/types';
import clsx from 'clsx';

const DefaultBadgeBackground = ({ level, className }: BadgeProps) => (
    <img className={clsx('absolute', className)} src={`/static/img/level-system/default/badge-bg-level-${level}.svg`} />
);

export { DefaultBadgeBackground };
